import { Flex } from "antd";
import { TurbineInfo } from "./Turbine";
import type { TurbineViewRenderProps } from "./TurbineViewRender";
import { ComponentsInfo } from "./Components";
import type { Dispatch } from "@reduxjs/toolkit";

type TurbineInformationProps = TurbineViewRenderProps & { dispatch: Dispatch };

export const TurbineInformation = (props: TurbineInformationProps) => {
  const { intl, turbineData, modalApi, currentRoute } = props;
  return (
    <Flex vertical gap="middle">
      <TurbineInfo
        currentRoute={currentRoute}
        intl={intl}
        turbineData={turbineData}
        modalApi={modalApi}
      />
      <ComponentsInfo
        intl={intl}
        currentRoute={currentRoute}
        turbineData={turbineData}
        modalApi={modalApi}
      />
    </Flex>
  );
};
